































import Vue from 'vue';

import BackButtonMobile from '@/components/buttons/BackButtonMobile.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import OutlineRoundedButton from '@/components/buttons/OutlineRoundedButton.vue';

export default Vue.extend({
  name: 'SceneShortcutName',
  components: {
    BackButtonMobile,
    BackButton,
    OutlineRoundedButton,
  },
  data(): {
    name: string;
  } {
    return {
      name: '',
    };
  },
  methods: {
    back() {
      this.$store.commit('resetSceneShortcutDraft');
      this.$router.push({
        name: 'ScenesSelector',
        params: this.$route.params,
      });
    },
    saveSceneShortcut() {
      this.$store.commit('saveSceneShortcutDraft', this.name);
      this.$router.push({ name: 'AreaControl', });
    },
  },
});
